import React from 'react'
import { Card, Flex, Table, TableColumnsType, Typography } from 'antd'
import styles from './styles.module.css'
import { PassiveBalanceFilter } from '../passiveBalanceFilter'
import { DataType } from './types'
import {
  $passiveBalances,
  $RDCBalances,
  getPassiveBalances,
  getRDCBalances,
} from './model'
import { useStore } from 'effector-react'
import { mapOpeningBalances, mapPassiveBalances } from './utils'

const columns: TableColumnsType<DataType> = [
  {
    title: '',
    dataIndex: 'name',
    key: 'name',
    width: '40%',
  },
  {
    title: 'Wallets',
    dataIndex: 'wallet',
    key: 'wallet',
    width: '20%',
  },
  {
    title: 'Accounts',
    dataIndex: 'account',
    key: 'account',
    width: '20%',
  },
  {
    title: 'Sum',
    dataIndex: 'result',
    key: 'result',
    width: '20%',
    align: 'right',
  },
]

export const PassiveBalances: React.FC = () => {
  const passiveBalances = useStore($passiveBalances)
  const RDCBalances = useStore($RDCBalances)
  const isPassivePending = useStore(getPassiveBalances.pending)
  const isRDCPending = useStore(getRDCBalances.pending)
  const isLoading = isPassivePending || isRDCPending

  return (
    <Card className={styles.passiveBalances}>
      <Flex gap={24} vertical>
        <Typography.Title level={4}>Passive</Typography.Title>
        <PassiveBalanceFilter />
        <Table
          className="overflow-auto"
          columns={columns}
          loading={isLoading}
          pagination={false}
          showHeader={false}
          dataSource={
            passiveBalances
              ? mapOpeningBalances(passiveBalances, RDCBalances)
              : []
          }
          rowClassName={(record) =>
            record.key === 1 && styles.passiveFooterRows
          }
        />
        <Table
          className="overflow-auto"
          columns={columns}
          loading={isLoading}
          dataSource={
            passiveBalances
              ? mapPassiveBalances(passiveBalances, RDCBalances)
              : []
          }
          pagination={false}
          rowClassName={(record) => {
            if (record?.children && record?.children.length > 0) {
              return styles.passiveBalancesParentRow
            }
            if (record.key === 13 || record.key === 14) {
              return styles.passiveFooterRows
            } else {
              return styles.passiveBalancesRows
            }
          }}
        />
      </Flex>
    </Card>
  )
}
